import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './print.css'
import { ImageContainer } from "../Image"
import { A4Sheet } from "../../../../../helpers/print"
import { Rectangle } from "../../../../../helpers/math"

export class PrintPreview extends Component {

    static propTypes = {
        determinePrintOrientation: PropTypes.func.isRequired,
        previewSheet: PropTypes.object.isRequired,
        printOrientationAngle: PropTypes.number.isRequired,
    }

    componentDidMount()
    {
        this.props.determinePrintOrientation()
    }

    render()
    {
        const sheet = A4Sheet()
        const frame = sheet.frame.rotate(this.props.printOrientationAngle)
        const frameWithMargin = new Rectangle(
            frame.width - sheet.margin.left - sheet.margin.right,
            frame.height - sheet.margin.top - sheet.margin.bottom
        )
        const viewScale = this.props.previewSheet.width / frame.width

        const scaledMargin = {
            top: sheet.margin.top * viewScale,
            bottom: sheet.margin.bottom * viewScale,
            left: sheet.margin.left * viewScale,
            right: sheet.margin.right * viewScale,
        }

        return (
            <div id="printPreview">
                <div
                    className="sheet"
                    style={{
                        width: this.props.previewSheet.width,
                        height: this.props.previewSheet.height,
                        paddingTop: scaledMargin.top,
                        paddingBottom: scaledMargin.bottom,
                        paddingLeft: scaledMargin.left,
                        paddingRight: scaledMargin.right,
                    }}
                >
                    <div className="media-title" style={{
                        top: scaledMargin.top / 2,
                        left: scaledMargin.left,
                        width: this.props.previewSheet.width - scaledMargin.left - scaledMargin.right
                    }}>
                        { this.props.title }
                    </div>
                    <ImageContainer id={this.props.id} frame={frameWithMargin} viewScale={viewScale} isInteractive={true}/>
                </div>
            </div>
        )
    }
}
